import { STATUS_LABELS } from '@/features/quality/labels';
import type { AnomalyStatus } from '@/features/quality/types';

const STYLES: Record<AnomalyStatus, string> = {
  open: 'bg-red-50 text-red-700 dark:bg-red-500/15 dark:text-red-300',
  acknowledged: 'bg-amber-50 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300',
  resolved: 'bg-green-50 text-green-700 dark:bg-green-500/15 dark:text-green-300',
};

export function AnomalyStatusPill({ status }: { status: AnomalyStatus }): JSX.Element {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${STYLES[status]}`}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
